import {CanActivateFn} from '@angular/router';
import {inject} from '@angular/core';
import {RouteService} from '../../services/route.service';
import {KeycloakWrapperService} from '../keycloak/keycloak-wrapper.service';

export const logoutGuard: CanActivateFn = () => {
    const _kcService: KeycloakWrapperService = inject(KeycloakWrapperService);
    const _routeService: RouteService = inject(RouteService);
    if (_kcService.getKeycloakInstance()?.authenticated) {
        _routeService.navigateToDefault().then(() => _kcService.logout());
    } else{
        _routeService.navigateToDefault().then(() => _kcService.login());
    }
    return true;
};
